"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AddEmployeeComponent;
var _react = _interopRequireDefault(require("react"));
var _Modal = require("@ccw-pwa-ui/Modal");
var _Input = require("@ccw-pwa-ui/Input");
var _HeaderText = require("@ccw-pwa-ui/HeaderText");
var _ai = require("react-icons/ai");
require("./userIndex.css");
var _fa = require("react-icons/fa");
var _Button = require("@ccw-pwa-ui/Button");
var _reactBootstrap = require("react-bootstrap");
var _DataTable = require("@ccw-pwa-ui/DataTable");
require("../../styles/addEmployeeComponent.css");
var _images = _interopRequireDefault(require("../../common_features/assets/images"));
function AddEmployeeComponent(props) {
  var _props$conEmail2, _props$email, _props$currentFilter, _props$currentFilter2, _props$successModalDa, _props$successModalDa2, _props$successModalDa3, _props$successModalDa4, _props$successModalDa5, _props$successModalDa6, _props$successModalDa7, _props$successModalDa8, _props$successModalDa9, _props$successModalDa10, _props$successModalDa11, _props$successModalDa12, _props$successModalDa13;
  /* The Two props editView Enable and email Edit is used to diff. between add employee and edit edit email view. */
  /* The Below Two functions will be used based uopn the use of Email Edit And Add Employee Feature to enable green tick Feature*/
  const isCheckSymbolEnabled = () => {
    return props.formErrorList.emailValid ? /*#__PURE__*/_react.default.createElement(_ai.AiFillExclamationCircle, {
      style: {
        fontSize: 16,
        color: '#E00932'
      }
    }) : getAiFillCheckCircleStyleEmail();
  };
  const isCheckSymbolEnabledConEmail = () => {
    var _props$conEmail;
    return ((_props$conEmail = props.conEmail) === null || _props$conEmail === void 0 ? void 0 : _props$conEmail.length) > 0 ? getAiFillCheckCircleStyleConEmail() : null;
  };
  const getAiFillCheckCircleStyle = () => {
    return !props.fName ? null : /*#__PURE__*/_react.default.createElement(_ai.AiFillCheckCircle, {
      style: {
        fontSize: 16,
        color: '#4F8309'
      }
    });
  };
  const getAiFillCheckCircleStyleEmail = () => {
    return !props.email ? null : /*#__PURE__*/_react.default.createElement(_ai.AiFillCheckCircle, {
      style: {
        fontSize: 16,
        color: '#4F8309'
      }
    });
  };
  const getAiFillCheckCircleStyleForm = () => {
    return !props.lName ? null : /*#__PURE__*/_react.default.createElement(_ai.AiFillCheckCircle, {
      style: {
        fontSize: 16,
        color: '#4F8309'
      }
    });
  };
  const getAiFillCheckCircleStyleConEmail = () => {
    return props.conEmailCheck ? /*#__PURE__*/_react.default.createElement(_ai.AiFillCheckCircle, {
      style: {
        fontSize: 16,
        color: '#4F8309'
      }
    }) : /*#__PURE__*/_react.default.createElement(_ai.AiFillExclamationCircle, {
      style: {
        fontSize: 16,
        color: '#E00932'
      }
    });
  };
  const headerStyleDisable = {
    display: "block",
    marginBottom: "8px",
    fontSize: 16,
    color: '#9A9A9A',
    fontWeight: 600,
    lineHeight: "22px"
  };
  const headerStyleEnable = {
    display: "block",
    marginBottom: "8px",
    fontSize: 16,
    color: '#333333',
    fontWeight: 600,
    lineHeight: "22px"
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      paddingLeft: "80px",
      paddingRight: "80px",
      marginTop: "10px"
    }
  }, props.isLoading && /*#__PURE__*/_react.default.createElement("div", {
    class: "addEmployeeLoader"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Spinner, {
    animation: "border"
  })), /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    variantBtn1: "primary-long",
    customIcon: props.customIcon,
    variantBtn2: "nav-link-button",
    btn2Style: {
      width: '100%',
      justifyContent: "center"
    },
    variant: props.ErrorModalVariant,
    modalHeaderText: props.ErrorModalHeaderText,
    modalHeaderTextStyle: {
      fontSize: 20,
      color: '#333333',
      fontWeight: 600,
      lineHeight: "25px",
      fontFamily: "Poppins"
    },
    modalDetailText: props.ErrorModalDetailText,
    modalDetailText2: props.ErrorModalDetailText2,
    modalDetailTextStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400,
      lineHeight: "22px",
      fontFamily: "Poppins",
      marginTop: 2
    },
    displayModal: props.errorModal,
    positiveActionButtonTitle: props.positiveActionErrorButtonTitle,
    negativeButtonActionTitle: props.negativeErrorButtonActionTitle,
    positiveAction: props.handleErrorModal,
    negativeAvtion: props.handleErrorCancelModal
  }), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "m-t-20"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: ""
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "click-cursor",
    onClick: props.handleBackButton
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerText: props.headerTextLinkTitle,
    variant: "header-text",
    headerStyle: {
      fontSize: 12,
      color: '#333333',
      fontWeight: 400,
      lineHeight: "18px",
      margin: '2px'
    }
  })), /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerText: props.headerTextPageLinkIcon,
    variant: "header-text",
    headerStyle: {
      fontSize: 12,
      color: '#333333',
      fontWeight: 400,
      lineHeight: "18px",
      margin: '2px'
    }
  }), /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerText: props.headerTextPageLinkText,
    variant: "header-text",
    headerStyle: {
      fontSize: 12,
      color: '#9A9A9A',
      fontWeight: 400,
      lineHeight: "18px",
      margin: '2px'
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "editViewUpperHeader"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "m-t-20 upperHeader"
  }, props.editViewEnable ? null : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "click-cursor",
    onClick: props.handleBackButton
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerText: /*#__PURE__*/_react.default.createElement(_fa.FaChevronLeft, {
      style: {
        color: '#008ABC'
      }
    }),
    variant: "header-text",
    headerStyle: {
      fontSize: 24,
      fontWeight: 200,
      lineHeight: "34px",
      marginRight: "20px"
    }
  }))), /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerText: props.headerTextPageTitle,
    variant: "header-text",
    headerStyle: {
      fontSize: 27,
      color: '#0B3471',
      fontWeight: 600,
      lineHeight: "34px"
    }
  })), /*#__PURE__*/_react.default.createElement("div", null, props.editViewEnable && !props.emailEdit ? /*#__PURE__*/_react.default.createElement("div", {
    class: "EditButton"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-12 col-md-6 editBtnStyle"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    icon: /*#__PURE__*/_react.default.createElement("img", {
      src: _images.default.whitePencil.default,
      alt: ""
    }),
    iconStyle: {
      marginRight: 8,
      marginTop: 3
    },
    variant: "primary-long",
    title: props.editText,
    onClick: props.handleEditBtn,
    buttonStyle: {
      width: "189px",
      height: "48px",
      borderColor: '#006E96',
      border: "2px solid #006E96"
    }
  }))) : null)), props.editViewEnable ? null : /*#__PURE__*/_react.default.createElement("div", {
    className: "m-t-20"
  }, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerText: props.headerTextDescOne,
    variant: "header-text",
    headerStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400,
      lineHeight: "24px"
    }
  })), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerText: props.headerTextDescTwo,
    variant: "header-text",
    headerStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400,
      lineHeight: "24px"
    }
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "m-t-20"
  }, /*#__PURE__*/_react.default.createElement("form", {
    noValidate: true
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row m-t-20 fields ".concat(props.editViewEnable && !props.emailEdit ? "disableFields" : "enableFields")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-12 col-md-6 input-icon ".concat(props.editViewEnable, " ? headerWidth : null} ")
  }, /*#__PURE__*/_react.default.createElement(_Input.Input, {
    inputType: "lable-input-error",
    isErrorFree: !props.formErrorList.fNameValid,
    headerProps: {
      headerStyle: props.editViewEnable && !props.emailEdit ? headerStyleDisable : headerStyleEnable,
      variant: "header-text",
      headerText: props.headerTextFName
    },
    inputProps: {
      disabled: props.editViewEnable && !props.emailEdit,
      value: props.fName,
      placeholder: props.headerTextFNamePlaceHolder,
      inputStyle: {},
      onchange: e => props.handleInputChange(e, "fName"),
      suffix: props.editViewEnable && !props.emailEdit ? null : props.formErrorList.fNameValid ? /*#__PURE__*/_react.default.createElement(_ai.AiFillExclamationCircle, {
        style: {
          fontSize: 16,
          color: '#E00932'
        }
      }) : getAiFillCheckCircleStyle(),
      testId: "fNameInput"
    },
    errorProps: {
      headerStyle: {
        fontSize: 12,
        color: '#FF2D55',
        marginBottom: 0
      },
      variant: "header-text",
      headerText: props.errorMessage.fName
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-12 col-md-6 input-icon ".concat(props.editViewEnable, " ? headerWidth : null} ")
  }, /*#__PURE__*/_react.default.createElement(_Input.Input, {
    inputType: "lable-input-error",
    isErrorFree: !props.formErrorList.lNameValid,
    headerProps: {
      headerStyle: props.editViewEnable && !props.emailEdit ? headerStyleDisable : headerStyleEnable,
      variant: "header-text",
      headerText: props.headerTextLName
    },
    inputProps: {
      disabled: props.editViewEnable && !props.emailEdit,
      value: props.lName,
      placeholder: props.headerTextLNamePlaceHolder,
      inputStyle: {},
      // onchange: (e) => { setConEmail(e.target.value) },
      onchange: e => props.handleInputChange(e, "lName"),
      suffix: props.editViewEnable && !props.emailEdit ? null : props.formErrorList.lNameValid ? /*#__PURE__*/_react.default.createElement(_ai.AiFillExclamationCircle, {
        style: {
          fontSize: 16,
          color: '#E00932'
        }
      }) : getAiFillCheckCircleStyleForm()
    },
    errorProps: {
      headerStyle: {
        fontSize: 12,
        color: '#FF2D55',
        marginBottom: 0
      },
      variant: "header-text",
      headerText: props.errorMessage.lName
    }
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "row m-t-20 fields ".concat(props.editViewEnable && !props.emailEdit ? "disableFields" : "enableFields")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-12 col-md-6 input-icon ".concat(props.editViewEnable, " ? headerWidth : null} ")
  }, /*#__PURE__*/_react.default.createElement(_Input.Input, {
    inputType: "lable-input-error",
    isErrorFree: !props.formErrorList.emailValid,
    headerProps: {
      headerStyle: props.editViewEnable && !props.emailEdit ? headerStyleDisable : headerStyleEnable,
      variant: "header-text",
      headerText: props.headerTextEmail
    },
    inputProps: {
      disabled: props.editViewEnable && !props.emailEdit,
      value: props.email,
      placeholder: props.headerTextEmailPlaceHolder,
      inputStyle: {},
      // onchange: (e) => { setConEmail(e.target.value) },
      onchange: e => props.handleInputChange(e, "email"),
      suffix: props.editViewEnable && !props.emailEdit ? null : isCheckSymbolEnabled()
    },
    errorProps: {
      headerStyle: {
        fontSize: 12,
        color: '#FF2D55',
        marginBottom: 0
      },
      variant: "header-text",
      headerText: props.errorMessage.email
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-12 col-md-6 input-icon ".concat(((_props$conEmail2 = props.conEmail) === null || _props$conEmail2 === void 0 ? void 0 : _props$conEmail2.toLowerCase()) !== ((_props$email = props.email) === null || _props$email === void 0 ? void 0 : _props$email.toLowerCase()) ? "P-error" : "", " ").concat(props.editViewEnable, " ? headerWidth : null")
  }, /*#__PURE__*/_react.default.createElement(_Input.Input, {
    onPaste: e => {
      e.preventDefault();
      return false;
    },
    onCopy: e => {
      e.preventDefault();
      return false;
    },
    inputType: "lable-input-error",
    isErrorFree: !props.formErrorList.conEmailValid,
    headerProps: {
      headerStyle: props.editViewEnable && !props.emailEdit ? headerStyleDisable : headerStyleEnable,
      variant: "header-text",
      headerText: props.headerTextConEmail
    },
    inputProps: {
      disabled: props.editViewEnable && !props.emailEdit,
      value: props.conEmail,
      placeholder: props.headerTextConEmailPlaceHolder,
      inputStyle: {},
      // onchange: (e) => { setConEmail(e.target.value) },
      onchange: e => props.handleInputChange(e, "conEmail"),
      suffix: props.editViewEnable && !props.emailEdit ? null : isCheckSymbolEnabledConEmail()
    },
    errorProps: {
      headerStyle: {
        fontSize: 12,
        color: '#FF2D55',
        marginBottom: 0
      },
      variant: "header-text",
      headerText: props.errorMessage.conEmail
    }
  }))), props.selectStoreBtn && !props.editViewEnable ? /*#__PURE__*/_react.default.createElement("div", {
    className: "row selectStoreDiv"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-14 col-md-6 footerBtn",
    "data-testid": "selectStoreDiv"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    disabled: props.storeTagBtnDisable,
    variant: "primary-long",
    title: "Select Stores",
    onClick: props.setEnableStoreComponentProp,
    buttonStyle: props.storeTagBtnDisable ? {
      borderColor: '#9A9A9A',
      backgroundColor: '#ffffff',
      color: '#9A9A9A',
      width: '100%',
      height: "46px",
      borderWidth: "medium",
      padding: 4
    } : {
      borderColor: '#006E96',
      backgroundColor: '#ffffff',
      color: '#006E96',
      width: '100%',
      height: "46px",
      borderWidth: "revert"
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    class: "selectedStoreText"
  }, props.storeTagBtnDisable ? props.noStoreMessage : null, props.selectedStoresCount ? /*#__PURE__*/_react.default.createElement("span", null, "".concat(props.selectedStoresCount, " store(s) selected")) : null)) : null, props.enableStoreComponentProp ? /*#__PURE__*/_react.default.createElement("div", {
    className: "store-assign-modal"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "store-assign-modal-sub-div"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-with-table-addUser",
    "data-testid": "modal-table"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    className: "d-flex p-3 flex-column"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerText: "Select Stores",
    variant: "header-text",
    headerStyle: {
      fontSize: 32,
      color: '#0B3471',
      fontWeight: 600,
      lineHeight: "42px"
    }
  }), /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerText: "Assign stores to the ".concat(props.userType === 4 ? "employee" : "technician", " from below"),
    variant: "header-text",
    headerStyle: {
      fontSize: 16,
      color: '#000000',
      fontWeight: 400,
      lineHeight: "22px",
      marginTop: 12,
      marginBottom: 8
    }
  }), /*#__PURE__*/_react.default.createElement(_Input.Input, {
    inputType: "filter-search-box",
    inputStyle: props.zipCodeValidation || props.characterLimitPopUp ? {
      width: "600px",
      height: "50px",
      display: "flex",
      margin: "10px 0px 10px 1px",
      borderColor: "#E00932"
    } : {
      width: "600px",
      height: "50px",
      display: "flex",
      margin: "10px 0px 10px 1px"
    },
    onKeyPress: props.handleOnKeyPress,
    inputProps: {
      placeholder: ((_props$currentFilter = props.currentFilter) === null || _props$currentFilter === void 0 ? void 0 : _props$currentFilter.value) === "Zip Code" ? "Enter 5 digit zip code" : "Search",
      inputVal: props.query,
      value: props.query,
      onchange: props.setQuery,
      disabled: props.searchDisabled,
      suffix: /*#__PURE__*/_react.default.createElement(_ai.AiOutlineSearch, {
        "data-testid": "suffix",
        style: props.query ? {
          fontSize: 25,
          color: '#9A9A9A',
          cursor: "pointer"
        } : {
          fontSize: 25,
          color: '#9A9A9A'
        },
        onClick: props.initiateQuerySearch
      }),
      inputStyle: {
        width: '326px'
      }
    },
    selectProps: {
      dropdownList: props.filterDropDown,
      itemClick: props.setCurrentFilter,
      selectedItem: ((_props$currentFilter2 = props.currentFilter) === null || _props$currentFilter2 === void 0 ? void 0 : _props$currentFilter2.value) || "Select",
      placeholder: "Please select filter",
      inputStyle: {
        width: '300px'
      }
    }
  }), props.characterLimitPopUp || props.zipCodeValidation ? /*#__PURE__*/_react.default.createElement("div", {
    className: "validationMessageStyle"
  }, props.characterLimitPopUp ? props.characterSizeValidationMessage : props.zipCodeValidationMessage) : null, /*#__PURE__*/_react.default.createElement(_DataTable.DataTable, {
    isReponsive: true,
    isLoading: props.isDataLoading,
    responsiveStyle: {
      height: '350px !important'
    },
    tableContainerStyle: {
      height: '350px !important'
    },
    checkboxPosition: "right",
    allowRowClick: props.allowRowClick,
    headerSchema: props.headerSchema,
    bodySchema: props.bodySchema,
    allRowSelected: props.allSelect,
    rowSelectedList: props.rowSelect,
    handleRowSelect: props.setRowSelected,
    handleAllRowSelected: props.setAllSelected,
    paginationProps: {
      totalLength: props.count,
      currentPage: props.currentPage,
      pageSize: props.pageSize,
      handlePageChange: props.handlePageChange,
      paginationStyle: {
        float: "right"
      }
    },
    loadingDataProps: {
      headingTitle: "Loading",
      headerDesc: "Please wait while we fetch records..."
    },
    noDataProps: {
      headingTitle: "No Results Found",
      headerDesc: "Try adjusting your search to find what you’re looking for."
    }
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: true,
    md: true,
    sm: true,
    className: "d-flex flex-row  justify-content-end  align-items-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex flex-row align-items-center modal-Btn-div"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    title: "Cancel",
    variant: "nav-link-button",
    className: "",
    buttonStyle: {
      width: 150,
      justifyContent: 'center'
    },
    onClick: props.handleStoreModalCancel
  }), /*#__PURE__*/_react.default.createElement(_Button.Button, {
    title: "Save",
    variant: "primary",
    className: "",
    buttonStyle: {
      width: 150,
      justifyContent: 'center',
      borderRadius: 10
    },
    onClick: props.handleStoreModalSubmit
  }))))) : null, !props.emailEdit && props.editViewEnable ? null : /*#__PURE__*/_react.default.createElement("div", {
    className: "row m-t-20"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-12 col-md-6 footerBtn"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: "primary-long",
    title: props.editViewEnable ? "Update" : "Send Invitation",
    onClick: props.editViewEnable ? props.updateHandleFunc : props.handleSubmit,
    disabled: Object.entries(props.formErrorList || {}).length > 0 || props.isLoading || props.oldEmail,
    buttonStyle: Object.entries(props.formErrorList || {}).length > 0 || props.oldEmail ? {
      borderColor: '#BFC1C4',
      backgroundColor: '#BFC1C4',
      color: '#9A9A9A',
      height: "42px"
    } : {
      borderColor: '#006E96',
      backgroundColor: '#006E96',
      color: '#FFFFFF',
      width: '100%',
      height: "46px"
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-12 col-md-6 cancelBtn"
  }, /*#__PURE__*/_react.default.createElement("span", {
    "data-testid": "cancel-btn-add-user",
    onClick: props.handleBackButton
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    navigationUrl: "",
    variant: "header-text",
    headerText: "Cancel",
    headerStyle: {
      display: "block",
      fontSize: 16,
      color: '#006E96',
      fontWeight: 700,
      lineHeight: "24px",
      padding: '7px',
      cursor: "pointer",
      marginLeft: 28
    }
  }))), props.editViewEnable ? null : /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    variant: "header-text",
    headerText: "*Invitation is valid for only 24 hours",
    headerStyle: Object.entries(props.formErrorList || {}).length > 0 ? {
      fontSize: 14,
      fontWeight: 700,
      lineHeight: "24px",
      padding: '2px',
      marginLeft: '18px',
      marginTop: '10px',
      color: '#BFC1C4'
    } : {
      fontSize: 14,
      fontWeight: 700,
      lineHeight: "24px",
      padding: '2px',
      marginLeft: '18px',
      marginTop: '10px'
    }
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "m-t-20"
  })), props.modalShow && /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    displayModal: props.modalShow,
    variant: (_props$successModalDa = props.successModalData) === null || _props$successModalDa === void 0 ? void 0 : _props$successModalDa.variant,
    displayCrossIcon: (_props$successModalDa2 = props.successModalData) === null || _props$successModalDa2 === void 0 ? void 0 : _props$successModalDa2.displayCrossIcon,
    modalHeaderText: (_props$successModalDa3 = props.successModalData) === null || _props$successModalDa3 === void 0 ? void 0 : _props$successModalDa3.modalHeaderText,
    modalHeaderTextStyle: (_props$successModalDa4 = props.successModalData) === null || _props$successModalDa4 === void 0 ? void 0 : _props$successModalDa4.modalHeaderTextStyle,
    modalHeaderIcon: true,
    modalDetailText: (_props$successModalDa5 = props.successModalData) === null || _props$successModalDa5 === void 0 ? void 0 : _props$successModalDa5.modalDetailText,
    modalDetailTextStyle: (_props$successModalDa6 = props.successModalData) === null || _props$successModalDa6 === void 0 ? void 0 : _props$successModalDa6.modalDetailTextStyle,
    modalDetailText2: (_props$successModalDa7 = props.successModalData) === null || _props$successModalDa7 === void 0 ? void 0 : _props$successModalDa7.modalSecondDetailText,
    modalDetailText2Style: (_props$successModalDa8 = props.successModalData) === null || _props$successModalDa8 === void 0 ? void 0 : _props$successModalDa8.modalDetailText2Style,
    positiveActionButtonTitle: (_props$successModalDa9 = props.successModalData) === null || _props$successModalDa9 === void 0 ? void 0 : _props$successModalDa9.positiveActionButtonTitle,
    negativeButtonActionTitle: (_props$successModalDa10 = props.successModalData) === null || _props$successModalDa10 === void 0 ? void 0 : _props$successModalDa10.negativeButtonActionTitle,
    positiveAction: (_props$successModalDa11 = props.successModalData) === null || _props$successModalDa11 === void 0 ? void 0 : _props$successModalDa11.positiveAction,
    negativeAvtion: (_props$successModalDa12 = props.successModalData) === null || _props$successModalDa12 === void 0 ? void 0 : _props$successModalDa12.negativeAction,
    crossIconAction: (_props$successModalDa13 = props.successModalData) === null || _props$successModalDa13 === void 0 ? void 0 : _props$successModalDa13.crossIconAction,
    btn1Style: {
      width: 300,
      marginLeft: 57,
      marginBottom: 16,
      marginTop: 26,
      height: 45
    },
    showCheckCircle: true,
    showExclaimationCircle: true
  }));
}